
<app-main-header  *ngIf="isHeaderVisible"> </app-main-header>
<div class="card">
  <div style="position:relative; width:100%; height: 500px;">
    <router-outlet ></router-outlet>  
    <div  class="demo-container" [bentoBusyLoader]="isBusyLoader"></div>
      <div class="overlay" *ngIf="isBusyLoader"></div> 
</div>
</div>

